import { BottomSheetTextInput } from '@gorhom/bottom-sheet'
import { Image as ExpoImage } from 'expo-image'
import { LinearGradient } from 'expo-linear-gradient'
import { cssInterop } from 'nativewind'
import { Platform, SectionList } from 'react-native'
import { Touchable } from 'react-native-gesture-handler'
import Animated from 'react-native-reanimated'
import Svg from 'react-native-svg'
import { WebView } from 'react-native-webview'

cssInterop(ExpoImage, { className: 'style' })
cssInterop(LinearGradient, { className: 'style' })
cssInterop(SectionList, { className: 'style', contentContainerClassName: 'contentContainerStyle' })
cssInterop(WebView, { className: 'style' })
cssInterop(Svg, { className: 'style' })
cssInterop(Touchable, { className: 'style' })
cssInterop(BottomSheetTextInput, { className: 'style' })

if (Platform.OS === 'web') {
  // Break the style if enabled on native
  cssInterop(Animated.View, { className: 'style' })
}
